module.exports = __webpack_public_path__ + "img/6_dice[4].7ffd6034.png";